import type { CheckoutGTMFlowType } from "@jti/tracker";

export type CheckoutFlowTracking = {
  checkoutFlowType: CheckoutGTMFlowType;
  shippingInfoPrefilled: boolean;
  paymentInfoPrefilled: boolean;
};

type GetCheckoutFlowTrackingArgs = {
  shippingInfoPrefilled: boolean;
  paymentInfoPrefilled: boolean;
};

export const getCheckoutFlowTracking = ({
  shippingInfoPrefilled,
  paymentInfoPrefilled,
}: GetCheckoutFlowTrackingArgs): CheckoutFlowTracking => {
  let checkoutFlowType: CheckoutGTMFlowType = "standard_flow";

  if (shippingInfoPrefilled && paymentInfoPrefilled) {
    checkoutFlowType = "fast_flow";
  } else if (shippingInfoPrefilled || paymentInfoPrefilled) {
    checkoutFlowType = "semi_fast_flow";
  }

  return { checkoutFlowType, shippingInfoPrefilled, paymentInfoPrefilled };
};
